import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { forkJoin, from, iif, Observable, of, OperatorFunction } from 'rxjs';
import { catchError, filter, map, mergeMap, pluck, switchMap, tap, toArray } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root'
})
export class FtthResourceLoaderService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    appService: AppService,
  ) {
    this.appData = appService.settings;
  }

  getJobStatus(): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/resources-inventory-loader/job/getJobStatus`);
  }

  load(file: File, progressCallback: (loaded: number, total: number) => void): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<any>(`${this.appData.webApi}/resources-inventory-loader/job/load`, formData, {
      reportProgress: true,
      observe: 'events',
    })
      .pipe(
        tap(event => {
          if (event.type === HttpEventType.UploadProgress) {
            progressCallback(event.loaded, event.total);
          }
        }),
        filter(event => event.type === HttpEventType.Response),
        map((event: HttpResponse<any>) => event.body),
      );
  }

}
